import moment from 'moment';

export const getDatePickerToMomentProps: () => {
  getValueProps: (value: any) => {
    value: any;
  };
  normalize: (value: any) => any;
} = () => ({
  getValueProps: (value: any) => ({
    value: value && moment(value) // Convert the value to a Moment object
  }),
  normalize: (value: any) => value && moment(value).format() // Convert the Moment object back to a formatted string
});

